import { render, staticRenderFns } from "./FormSubTitle.vue?vue&type=template&id=3f1ae3e6&"
import script from "./FormSubTitle.vue?vue&type=script&lang=js&"
export * from "./FormSubTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports